import { createAsyncThunk } from "@reduxjs/toolkit";
import request from "../../request/request";

export const getAllSystemPrompts = createAsyncThunk(
  "getAllSystemPrompts",
  async (params, { rejectWithValue }) => {
    try {
      const { limit, offset, search, fields } = params;

      // Use URLSearchParams to construct query string
      const queryParams = new URLSearchParams();

      if (limit) queryParams.append("limit", limit);
      if (offset) queryParams.append("offset", offset);
      if (search?.trim()) queryParams.append("search", search.trim());
      if (fields) queryParams.append("fields", fields);

      const response = await request(
        `/api/v1/system-prompts/get?${queryParams.toString()}`,
        {
          method: "GET",
          auth: true,
        }
      );

      if (response?.data) {
        return response;
      }

      return rejectWithValue(response?.error || "Something went wrong");
    } catch (error) {
      return rejectWithValue(error?.message || "Something went wrong");
    }
  }
);

export const getAllSystemPromptsByType = createAsyncThunk(
  "getAllSystemPromptsByType",
  async (params, { rejectWithValue }) => {
    try {
      const { type } = params;

      // Use URLSearchParams to construct query string
      const queryParams = new URLSearchParams();

      if (type) queryParams.append("type", type);

      const response = await request(
        `/api/v1/system-prompts/get-by-type?${queryParams.toString()}`,
        {
          method: "GET",
          auth: true,
        }
      );

      if (response?.data) {
        return response;
      }

      return rejectWithValue(response?.error || "Something went wrong");
    } catch (error) {
      return rejectWithValue(error?.message || "Something went wrong");
    }
  }
);
